import req from 'shared/req';

export const RECEIVE_NOT_OFFERED_COLLEGE_TERMS = 'RECEIVE_NOT_OFFERED_COLLEGE_TERMS';

export function getFollowedCollegesNextTransferTerms(term) {
  return (dispatch) =>
    req({
      url: '/students/followed_colleges_next_transfer_terms',
      method: 'get',
      data: {term: term},
    }).then((colleges) => {
      dispatch(receiveFollowedCollegesNextTransferTerms(colleges));
      return receiveFollowedCollegesNextTransferTerms(colleges);
    });
}
export function receiveFollowedCollegesNextTransferTerms(colleges) {
  return {
    type: RECEIVE_NOT_OFFERED_COLLEGE_TERMS,
    payload: colleges,
  };
}
